import { all, put, race, take, takeEvery } from "redux-saga/effects";
import { CREATE_OBJECT_SUCCESS, UPDATE_OBJECT_SUCCESS } from "../actions/objects";
import { StoreObject } from "../util/objects";
import { HLAEngineVariable } from "../types/shared/v2/HLAEngineVariable";
import { RUN_PIPELINE_FAILURE, RUN_PIPELINE_SUCCESS, runPipeline } from "../actions/pipeline";

export function* hlaEngineVariableSaga(): Generator<any, any, any> {
  yield all([
    // Re-exec the hla rule engine on modification of patient's variables
    takeEvery((action) => action.namespace === "hla-engine-variable-v1" && (action.type === UPDATE_OBJECT_SUCCESS || action.type === CREATE_OBJECT_SUCCESS), runPatientRuleEngineFromHLAEngineVariable)
  ]);
}

function* runPatientRuleEngineFromHLAEngineVariable(
  action
): Generator<any, any, any> {
  const hlaEngineVariable: StoreObject<HLAEngineVariable> = action.object;

  const inlogId = hlaEngineVariable?.data?.ref?.patient?.inlogId;
  if (!inlogId) return;

  yield runPatientRuleEngine(inlogId);
}

export function* runPatientRuleEngine(inlogId: string) {
  let result: any;

  try {
    const input = { inlogId };
    yield put(runPipeline("exec-rule-engine", input, {
      startMessage: `Le moteur de règles a été relancé pour le patient '${inlogId}'...`,
      successMessage: `Le moteur de règles a été réexécuté pour le patient '${inlogId}'.`,
      errorMessage: `Erreur lors de la réexécution du moteur de règles pour le patient '${inlogId}' !`
    }));

    result = yield race({
      success: take((action) => action.type === RUN_PIPELINE_SUCCESS && action.input === input),
      failure: take((action) => action.type === RUN_PIPELINE_FAILURE && action.input === input)
    })
  } catch (err) {
    return
  }

  if (result.failure) {
    return;
  }
}